module.exports = __webpack_public_path__ + "static/media/img-quiz-2.0fb29881.jpg";